// extracted by mini-css-extract-plugin
module.exports = {"header":"ConfirmAccountPickOwner_header__28LGn","formCta":"ConfirmAccountPickOwner_formCta__29wRh"};